import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M11.192 1.25c-3.576 0-6.542 2.603-7.125 6.02a4.38 4.38 0 0 0-2.817 4.097 4.377 4.377 0 0 0 4.371 4.383h1.367L5.85 17.707a.75.75 0 0 0 1.298.753l1.5-2.583a1 1 0 0 0 .058-.127h5.78l-1.136 1.957a.75.75 0 0 0 1.298.753l1.5-2.583a1 1 0 0 0 .058-.127h.96c3.085 0 5.583-2.51 5.583-5.6 0-3.06-2.45-5.55-5.495-5.598a7.22 7.22 0 0 0-6.063-3.302m-5.7 6.665c.292-2.902 2.734-5.165 5.7-5.165 2.141 0 4.01 1.18 4.993 2.93a.75.75 0 0 0 .704.38q.138-.009.277-.009a4.09 4.09 0 0 1 4.084 4.1c0 2.266-1.83 4.099-4.084 4.099H5.621a2.877 2.877 0 0 1-2.871-2.883c0-1.353.928-2.487 2.177-2.799a.75.75 0 0 0 .565-.653"
      clipRule="evenodd"
    />
    <path d="M11.327 18.357a.75.75 0 0 0-1.32-.714L8.34 20.727a.75.75 0 1 0 1.32.713z" />
  </>
);

const Weather12 = Icon('weather-12', svgContents);

export default Weather12;
